<app-header *ngIf="!hideHeaderFooter"></app-header>
<router-outlet></router-outlet>
<!-- <ng-http-loader [spinner]="skThreeBounce" *ngIf="activeComponent != 'DetailEpisodeComponent'"></ng-http-loader> -->
<app-footer *ngIf="!hideHeaderFooter && delayFooter"></app-footer>
